import * as Yup from "yup";

export const initialValues = {
  startDate: null,
  startTime: "00:00:00",
  endTime: "00:00:00",
  description: null,
};

const OvertimeSchema = Yup.object().shape({
  startDate: Yup.string().required("Please select."),
  description: Yup.string().required("Please enter."),
  startTime: Yup.string()
    .required('Start time is required'),
  endTime: Yup.string()
    .required('End time is required')
  //   .test('is-greater', 'End time must be after start time', function (value) {
  //     const { startTime } = this.parent;
  //     if (!startTime || !value) {
  //       return true; // Skip validation if startTime or endTime is not set
  //     }
  //     return new Date(`1970-01-01T${value}`) > new Date(`1970-01-01T${startTime}`);
  //   })
});

export default OvertimeSchema;
